import React from 'react';
import { Mail } from 'lucide-react';
export function PrivacyPolicyContent() {
  return <div className="text-gray-300 space-y-6 leading-relaxed" data-id="element-295">
      <p className="text-lg text-white font-semibold" data-id="element-296">
        Última actualización: Enero 2024
      </p>

      <section data-id="element-297">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-298">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-299">
          En MÉTODO CIERRE 90' recopilamos únicamente la información necesaria
          para procesar tu compra y entregarte el producto digital:
        </p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-300">
          <li data-id="element-301">Nombre y apellido</li>
          <li data-id="element-302">Dirección de correo electrónico</li>
          <li data-id="element-303">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
        </ul>
      </section>

      <section data-id="element-304">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-305">
          2. Uso de la Información
        </h3>
        <p data-id="element-306">Utilizamos tu información para:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-307">
          <li data-id="element-308">Procesar y completar tu compra</li>
          <li data-id="element-309">Enviarte el acceso al producto digital adquirido</li>
          <li data-id="element-310">Comunicarnos contigo sobre tu pedido</li>
          <li data-id="element-311">
            Enviarte actualizaciones importantes sobre el producto (solo si lo
            autorizas)
          </li>
        </ul>
      </section>

      <section data-id="element-312">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-313">
          3. Protección de Datos
        </h3>
        <p data-id="element-314">
          Implementamos medidas de seguridad para proteger tu información
          personal. Utilizamos encriptación SSL y trabajamos con procesadores de
          pago certificados que cumplen con los estándares PCI-DSS.
        </p>
      </section>

      <section data-id="element-315">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-316">
          4. Compartir Información
        </h3>
        <p data-id="element-317">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cuando
          la ley lo requiera.
        </p>
      </section>

      <section data-id="element-318">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-319">5. Tus Derechos</h3>
        <p data-id="element-320">Tienes derecho a:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-321">
          <li data-id="element-322">Acceder a tu información personal</li>
          <li data-id="element-323">Solicitar la corrección de datos incorrectos</li>
          <li data-id="element-324">Solicitar la eliminación de tus datos</li>
          <li data-id="element-325">Retirar tu consentimiento para comunicaciones de marketing</li>
        </ul>
      </section>

      <section data-id="element-326">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-327">6. Cookies</h3>
        <p data-id="element-328">
          Utilizamos cookies esenciales para el funcionamiento del sitio web y
          para mejorar tu experiencia de usuario. Puedes configurar tu navegador
          para rechazar cookies, aunque esto puede afectar algunas
          funcionalidades.
        </p>
      </section>

      <section data-id="element-329">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-330">7. Contacto</h3>
        <p data-id="element-331">
          Si tienes preguntas sobre nuestra política de privacidad, contáctanos
          en:
        </p>
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-gold-500 hover:underline inline-flex items-center gap-2 mt-2" data-id="element-332">
          <Mail className="w-4 h-4" data-id="element-333" />
          contactomikioscodigital@gmail.com
        </a>
      </section>
    </div>;
}
export function TermsAndConditionsContent() {
  return <div className="text-gray-300 space-y-6 leading-relaxed" data-id="element-334">
      <p className="text-lg text-white font-semibold" data-id="element-335">
        Última actualización: Enero 2024
      </p>

      <section data-id="element-336">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-337">
          1. Aceptación de Términos
        </h3>
        <p data-id="element-338">
          Al comprar y utilizar MÉTODO CIERRE 90', aceptas estos términos y
          condiciones. Si no estás de acuerdo, por favor no realices la compra.
        </p>
      </section>

      <section data-id="element-339">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-340">
          2. Descripción del Producto
        </h3>
        <p data-id="element-341">MÉTODO CIERRE 90' es un producto digital (ebook) que incluye:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-342">
          <li data-id="element-343">Ebook principal "Adiós al Caos por el Estrés Laboral"</li>
          <li data-id="element-344">6 ebooks complementarios (bonos)</li>
          <li data-id="element-345">Plantillas y recursos descargables</li>
        </ul>
        <p className="mt-3" data-id="element-346">
          El producto es de naturaleza digital y se entrega mediante descarga
          inmediata tras la confirmación del pago.
        </p>
      </section>

      <section data-id="element-347">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-348">3. Precio y Pago</h3>
        <p data-id="element-349">
          El precio del producto se muestra claramente en el sitio web.
          Aceptamos pagos mediante tarjeta de crédito/débito y otros métodos
          procesados por nuestro proveedor de pagos seguro.
        </p>
      </section>

      <section data-id="element-350">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-351">
          4. Política de Reembolso
        </h3>
        <p data-id="element-352">
          Ofrecemos una garantía de satisfacción de 30 días. Si no estás
          satisfecho con el producto, puedes solicitar un reembolso completo
          dentro de los 30 días posteriores a la compra contactándonos a:
        </p>
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-gold-500 hover:underline inline-flex items-center gap-2 mt-2" data-id="element-353">
          <Mail className="w-4 h-4" data-id="element-354" />
          contactomikioscodigital@gmail.com
        </a>
      </section>

      <section data-id="element-355">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-356">
          5. Uso del Producto
        </h3>
        <p data-id="element-357">
          Al adquirir MÉTODO CIERRE 90', obtienes una licencia personal e
          intransferible para:
        </p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-358">
          <li data-id="element-359">Descargar y utilizar el contenido para tu uso personal</li>
          <li data-id="element-360">Imprimir copias para tu uso personal</li>
        </ul>
        <p className="mt-3 font-semibold text-white" data-id="element-361">NO está permitido:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 ml-4" data-id="element-362">
          <li data-id="element-363">Compartir, revender o distribuir el contenido</li>
          <li data-id="element-364">Reproducir el contenido públicamente sin autorización</li>
          <li data-id="element-365">Modificar o crear obras derivadas sin permiso</li>
        </ul>
      </section>

      <section data-id="element-366">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-367">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-368">
          Todo el contenido de MÉTODO CIERRE 90' está protegido por derechos de
          autor. La propiedad intelectual pertenece a los creadores del método.
        </p>
      </section>

      <section data-id="element-369">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-370">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-371">
          MÉTODO CIERRE 90' es una herramienta de productividad y organización.
          No sustituye el asesoramiento profesional en salud mental, médico o
          psicológico. Si experimentas estrés crónico severo, consulta con un
          profesional de salud mental.
        </p>
      </section>

      <section data-id="element-372">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-373">8. Modificaciones</h3>
        <p data-id="element-374">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios se publicarán en esta página con la fecha de
          actualización correspondiente.
        </p>
      </section>

      <section data-id="element-375">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-376">9. Contacto</h3>
        <p data-id="element-377">Para cualquier consulta sobre estos términos y condiciones:</p>
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-gold-500 hover:underline inline-flex items-center gap-2 mt-2" data-id="element-378">
          <Mail className="w-4 h-4" data-id="element-379" />
          contactomikioscodigital@gmail.com
        </a>
      </section>
    </div>;
}
export function ContactContent() {
  return <div className="text-gray-300 space-y-8 leading-relaxed" data-id="element-380">
      <section className="text-center" data-id="element-381">
        <h3 className="text-2xl font-bold text-white mb-4" data-id="element-382">
          ¿Necesitas ayuda?
        </h3>
        <p className="text-lg mb-6" data-id="element-383">
          Estamos aquí para ayudarte con cualquier pregunta sobre MÉTODO CIERRE
          90'
        </p>
      </section>

      <section className="bg-white/5 border border-gold-500/20 rounded-xl p-8 text-center" data-id="element-384">
        <Mail className="w-12 h-12 text-gold-500 mx-auto mb-4" data-id="element-385" />
        <h4 className="text-xl font-bold text-white mb-3" data-id="element-386">Email de Soporte</h4>
        <a href="mailto:contactomikioscodigital@gmail.com" className="text-gold-500 hover:text-gold-400 text-lg font-medium transition-colors" data-id="element-387">
          contactomikioscodigital@gmail.com
        </a>
        <p className="text-gray-400 text-sm mt-4" data-id="element-388">
          Tiempo de respuesta: 24-48 horas hábiles
        </p>
      </section>

      <section data-id="element-389">
        <h4 className="text-xl font-bold text-white mb-4" data-id="element-390">
          Preguntas Frecuentes
        </h4>
        <div className="space-y-4" data-id="element-391">
          <div className="bg-white/5 rounded-lg p-4" data-id="element-392">
            <p className="font-semibold text-white mb-2" data-id="element-393">
              ¿Cómo accedo al producto después de la compra?
            </p>
            <p className="text-sm" data-id="element-394">
              Recibirás un email inmediatamente después de confirmar tu pago con
              el enlace de descarga y acceso a todos los materiales.
            </p>
          </div>

          <div className="bg-white/5 rounded-lg p-4" data-id="element-395">
            <p className="font-semibold text-white mb-2" data-id="element-396">
              ¿Puedo solicitar un reembolso?
            </p>
            <p className="text-sm" data-id="element-397">
              Sí, ofrecemos garantía de 30 días. Si no estás satisfecho,
              contáctanos y procesaremos tu reembolso.
            </p>
          </div>

          <div className="bg-white/5 rounded-lg p-4" data-id="element-398">
            <p className="font-semibold text-white mb-2" data-id="element-399">
              ¿El contenido se actualiza?
            </p>
            <p className="text-sm" data-id="element-400">
              Sí, recibirás acceso a todas las actualizaciones futuras del
              método sin costo adicional.
            </p>
          </div>
        </div>
      </section>

      <section className="border-t border-white/10 pt-6" data-id="element-401">
        <p className="text-center text-gray-400" data-id="element-402">
          Para consultas sobre pedidos, reembolsos, acceso al producto o
          cualquier otra pregunta, no dudes en escribirnos. Estamos
          comprometidos a brindarte la mejor experiencia posible.
        </p>
      </section>
    </div>;
}